/**
 * @file An example of how to use the date input component.
 */
import { Form, FormProvider, SuperSchema } from '@updater/ui-informant';

export const schema: SuperSchema = {
  type: 'object',
  properties: {
    dateOfBirth: {
      type: 'string',
      ui: {
        component: 'date',
        label: 'Date',
        width: 0.5,
      },
    },
  },
};

export const MyForm = () => {
  const handleSubmit = (values: unknown) => {
    alert(`Submitted values: ${JSON.stringify(values, null, 2)}`);
  };

  return (
    <>
      <FormProvider schema={schema} onSubmit={handleSubmit}>
        <Form />
      </FormProvider>
    </>
  );
};
